"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _importUserCoupon = require("@/api/importUserCoupon");
var _auth = require("@/utils/auth");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'UserCouponImport',
  data: function data() {
    return {
      uploadUrl: process.env.VUE_APP_BASE_API + '/api/admin/upload/file',
      uploadData: {
        model: 'excel',
        pid: 0
      },
      uploading: false,
      loading: false,
      form: {
        url: '',
        customerId: '',
        appId: '',
        goldCardId: '',
        normalCardId: '',
        specialCardId: '',
        tokenType: 2
      }
    };
  },
  computed: {
    headers: function headers() {
      return {
        Authorization: 'Bearer ' + (0, _auth.getToken)()
      };
    }
  },
  methods: {
    beforeUpload: function beforeUpload() {
      this.uploading = true;
    },
    handleSuccess: function handleSuccess(res) {
      var _res$data;
      this.uploading = false;
      // 后端返回 {data:{url:xxx}} 或 {url:xxx}
      var url = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.url) || (res === null || res === void 0 ? void 0 : res.url);
      if (!url) {
        this.$message.error('上传失败，未返回文件地址');
        return;
      }
      this.form.url = url;
      this.$message.success('上传成功');
    },
    handleError: function handleError() {
      this.uploading = false;
      this.$message.error('上传失败');
    },
    handleSubmit: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.form.url) {
                _context.n = 1;
                break;
              }
              this.$message.warning('请先上传Excel文件');
              return _context.a(2);
            case 1:
              if (!(!this.form.customerId || !this.form.appId)) {
                _context.n = 2;
                break;
              }
              this.$message.warning('客户ID与应用ID不能为空');
              return _context.a(2);
            case 2:
              this.loading = true;
              _context.p = 3;
              _context.n = 4;
              return (0, _importUserCoupon.importUserCoupon)(this.form);
            case 4:
              this.$message.success('导入成功');
              _context.n = 6;
              break;
            case 5:
              _context.p = 5;
              _t = _context.v;
              this.$message.error((_t === null || _t === void 0 ? void 0 : _t.msg) || (_t === null || _t === void 0 ? void 0 : _t.message) || '导入失败');
            case 6:
              _context.p = 6;
              this.loading = false;
              return _context.f(6);
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[3, 5, 6, 7]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }
};